import { useCallback, useEffect, useState } from "react";
import AccessPolicyManager from "../components/admin/AccessPolicyManager";
import AdminManagementLayout from "../components/admin/AdminManagementLayout";
import { API } from "../data/siteData";
import useAdminAccess from "../hooks/useAdminAccess";

export default function AdminAccessPolicyPage() {
  const accessState = useAdminAccess();
  const [investors, setInvestors] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [state, setState] = useState("loading");

  const loadPolicy = useCallback(async () => {
    try {
      const [investorsResponse, documentsResponse] = await Promise.all([
        fetch(`${API}/admin/investors`, { credentials: "include" }),
        fetch(`${API}/admin/documents`, { credentials: "include" }),
      ]);
      if (!investorsResponse.ok || !documentsResponse.ok) throw new Error();
      setInvestors(await investorsResponse.json());
      setDocuments(await documentsResponse.json());
      setState("ready");
    } catch {
      setState("error");
    }
  }, []);

  useEffect(() => {
    if (accessState === "ready") loadPolicy();
  }, [accessState, loadPolicy]);

  if (accessState === "loading" || state === "loading") return <main className="portal-state" data-testid="admin-access-policy-loading">Loading investor access controls…</main>;
  if (state === "error") return <main className="portal-state" data-testid="admin-access-policy-error">Investor access controls are temporarily unavailable.</main>;

  return <AdminManagementLayout active="access" eyebrow="Control Room authorization" title="INVESTOR ACCESS"><AccessPolicyManager investors={investors} documents={documents} onRefresh={loadPolicy} /></AdminManagementLayout>;
}